export default {
  closeButton: {},
  stInfoModalContent: {},
  modalTabsList: {},
  headerModal: {},
  infoBlock: {},
  infoDiscover:{},
  infoAdvantages:{},
  infoAdvantagesLevel:{},
  advantagesContainer:{},
  imageLevel:{
    width: '200px',
  },
  subTitleST:{
    font: "400 14px Roboto",
    color: data => data.STgoldEurostars,
    '@media (min-width:801px)': {
      fontSize: '20px',
    },
  },
  advantage:{
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    width: '33%',
    '@media (min-width:801px)': {
      flexDirection: 'row',
    },
    
  },
  imageAdvantage:{
    '& svg':{
      width: '40px',
      height: '40px',
      fill: data => data.STdefaultTier,
    }
  },
  descriptionText:{
    font: "300 12px Roboto",
    '@media (min-width:801px)': {
      fontSize: '16px',
    },
  },
  descriptionAdvantages:{
    display: 'flex',
    flexDirection: 'column'
  },
  stInfoModalStyle: {
    position: 'fixed',
    top: '0',
    right: '0',
    bottom: '0',
    left: '0',
    zIndex: '600',
    background: 'rgba(0,0,0,0.5)',
    padding: '0',
    '& $stInfoModalContent': {
      '@media (min-width:901px)': {
        right: '0',
        width: '800px',
        WebkitTransition: '0.5s',
        OTransition: '0.5s',
        MsTransition: '0.5s',
        MozTransition: '0.5s',
        transition: '0.5s',
        left: 'auto',
        padding: '0px 60px 60px'
      },
      position: 'absolute',
      top: '0',
      right: '0',
      left: '0',
      bottom: '0',
      overflow: 'auto',
      background: '#fff',
      padding: '0px 20px 20px',
      '& $closeButton': {
        color: data => data.mainColor,
        position: 'fixed',
        //right: '20px',
        //top: '20px',
        height: '24px',
        //width: '24px',
        width: '24px',
        background: 'transparent',
        border: 'none',
        zIndex: '502',
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'flex-end',
        outline: 'none',
        top: '0px',
        right: '0px',
        padding: '25px 20px',
        alignItems: 'center',
        '& > span': {
          font: '20px Icons',
        },
        '&:lang(ar)': {
          right: 'auto',
          left: '10px',
          '@media(min-width:801px)': {
            right: 'auto',
            left: '30px',
          }
        },
        '@media(min-width:801px)': {
          right: '30px',
          top: '8px',
          width: 'auto',
        },
        '@media(max-width:800px)': {
          padding: '20px 25px',
        },
      },
      '& $modalTabsList': {
        '& $headerModal': {
          '@media (min-width:801px)': {
            fontSize: '24px',
            padding: '20px 40px 20px 20px',
          },
          '@media (min-width: 901px)': {
            paddingLeft: '0px',
          },
          font: "500 18px Roboto",
          color: data => data.mainColor,
          padding: '10px 40px 10px 20px',
          textAlign: 'left',
          top: '0',
          background: '#fff',
          zIndex: '501',
          position: 'sticky',
          '&:lang(ar)': {
            paddingRight: "20px",
            paddingLeft: "40px",
            textAlign: "right",
            '@media (min-width: 801px)': {
              paddingLeft: "60px",
              paddingRight: "30px",
              textAlign: "right"
            }
          }
        },
      },
      '& $infoBlock': {
        font: "300 13px 'Roboto',sans-serif",
        background: '#fff',
        color: '#000',
        '@media (min-width: 801px)': {
          textAlign: 'left',
        },
        '@media (min-width: 901px)': {
          position: 'relative',
          right: '20px',
        },
        '& $infoDiscover': {
          '& > span': {
            padding: '0 20px 10px',
            display: 'block',
            textAlign: 'left',
            '&:lang(ar)': {
              textAlign: 'right'
            },
            '&$descriptionText': {
                paddingBottom: '25px'
            },
          },
        },
        '& $infoAdvantages': {
          paddingBottom: '24px',
          '&$infoAdvantagesLevel':{
            paddingBottom: '0',
            '& > span': {
              paddingBottom: 'unset',
            },
          },
          '& > span': {
            padding: '0 20px 10px',
            display: 'block',
            textAlign: 'left',
            '&:lang(ar)': {
              textAlign: 'right'
            }
          },
          '& $advantagesContainer': {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            '@media (min-width:801px)': {
              paddingLeft: '30px'
            }
          }
        },
      },
      '&:lang(ar)': {
        '@media (min-width: 801px)': {
          right: 'auto',
          left: '0'
        }
      }
    }
  },
  mobileTable:{},
  advantagesTable:{
    backgroundColor: '#fff',
    borderCollapse: 'collapse',
    borderBottom: '1px solid #15152A',
    borderTop: '1px solid #15152A',
    width: '99%',
    margin: '24px 0 auto',
    userSelect: 'none',
    pointerEvents: 'auto',
    position: 'relative',
    boxSizing: 'border-box',
    minHeight: '695px',
    '& tr':{
      padding: '0px',
      width: '900px',
      height: '60px',
      font: '14px Roboto, sans-serif',
    },
    '& td': {
      padding: '20px 0',
      font: '14px Roboto, sans-serif',
      overflow: 'visible',
      position: 'relative',
    },
    '& svg': {
      width: '20px',
      height: '20px'
    },
    '&$mobileTable':{
      margin: '0px auto',
    },
    '& tr:first-of-type':{
      '@media (min-width: 801px)': {
        borderBottom: '1px solid #15152A',
      }
    },
    '@media (min-width: 801px)': {
      borderTop: 'none',
      tableLayout: 'fixed',
    }
  },
  tiersValue: {
    alignContent: 'flex-start'
  },
  tierContent: {
    height: '100%',
    width: '100%',
    textAlign: 'center',
  },
  trTiersLogo:{
    '& > td':{
      '&:first-child': {
        width: '312px',
      },
    }
  },
  advantageValue: {
    textAlign: 'left',
  },
  subtitleText: {
    font: '12px Roboto, sans-serif',
    color: data => data.STgoldTier,
    marginTop: '1px',
  },
  stSilverTier: {
    fill: data => data.STsilverTier,
    color: data => data.STsilverTier,
    borderColor: data => data.STsilverTier
  },
  stGoldTier: {
    fill: data => data.STgoldTier,
    color: data => data.STgoldTier,
    borderColor: data => data.STgoldTier
  },
  stBlueTier: {
    fill: data => data.STblueTier,
    color: data => data.STblueTier,
    borderColor: data => data.STblueTier
  },
  stDefault: {
    fill: data => data.STdefaultTier,
    color: data => data.STdefaultTier,
    borderColor: data => data.STdefaultTier,
  },
  richtextRequiredBooks:{},
  tierInfo: {
    textAlign: 'left',
    '& $richtextRequiredBooks': {
      marginTop: '5px',
      font: '14px Roboto, sans-serif',
    },
    '& svg': {
      width: '150px',
      height: '90px',
      '@media (min-width: 901px)': {
        width: '135px',
        height: 'unset',
      }
    },
    '&$mobileTable':{
      display: 'flex',
      justifyContent: 'flex-end',
      flexDirection: 'column',
      height: '114px'
    }
  },
  sliderWrapper: {
    order: '3',
    overflow: 'hidden',
  },
  benefitsTable:{
    top: '0',
    minHeight: '830px',
  },
  slideButton:{},
  nextButton:{},
  prevButton:{},
  superiorWrapper:{},
  slideDots:{},
  selected:{},
  buttonSlide:{},
  buttonsContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '2em',
    order: '1',
    '@media (min-width: 601px)': {
      gap: '1em'
    },

    '& $buttonSlide': {
      height: '1em',
      width: '1em',
      border: 'solid #cfc8b7',
      borderWidth: '0 3px 3px 0',
      display: 'inline-block',
      padding: '3px',
      position: 'relative',
    },

    '& $buttonSlide:hover': {
      outline: 'none',
    },

    '& $buttonSlide:focus': {
      outline: 'none',
    },

    '& $nextButton': {
      transform: 'rotate(-45deg)',
      '&:before':{
        content: "''",
        position: 'absolute',
        left: '-12px',
        top: '-12px',
        width: '40px',
        height: '40px',
        transform: 'rotate(45deg)',
      }
    },

    '& $prevButton': {
      transform: 'rotate(135deg)',
      '&:before':{
        content: "''",
        position: 'absolute',
        left: '-12px',
        top: '-12px',
        width: '40px',
        height: '40px',
        transform: 'rotate(45deg)',
      }
    },

    '& $superiorWrapper': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      width: '100%',
      justifyContent: 'space-between',
      boxSizing: 'border-box',
      padding: '0 20px',
    },

    '& $slideDots': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      order: '2',
      textTransform: 'uppercase',
      '& > button':{
        font: '500 14px Roboto',
        '&.dotSelected': {
          borderBottom: '2px solid',
        },
        '&.silver': {
          color: data => data.STsilverTier,
        },
        '&.gold': {
          color: data => data.STgoldTier,
        },
        '&.blue': {
          color: data => data.STblueTier,
        },
      },
      '@media (max-width: 400px)': {
        gap: '55px',
      },
      gap: '90px',
      '@media (min-width: 901px)': {
        gap: '150px',
      },
    },

    '& $slideDots:hover': {
      outline: 'none',
    },

    '& $slideDots:focus': {
      outline: 'none',
    },
  },
  slideContainer:{
    display: 'flex',
    flexDirection: 'column',
    gap: '1em',
  },
  levelST:{},
  minHeightWraper:{
    '& > div':{
      height: 'unset !important',
      minHeight: '830px',
      '& $levelST':{
        position: 'unset !important'
      }
    }
  },
  bookInfoWrapper:{
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    margin: '10px auto 40px auto',
    '@media (min-width: 801px)': {
      margin: '10px 25px 40px 2px'
    },
    '@media (min-width: 901px)': {
      padding: '0px 20px 20px 20px',
      justifyContent: 'flex-start',
      gap: '4em',
      margin: '10px auto 20px 40px',
    },
    '& > :nth-child(2)': {
      margin: '0 5px 0 0'
    }
  },
  advantageIcon:{
    marginRght: '10px',
  },
  advantageName:{
    display: 'flex',
    alignItems: 'center',
    height: '100%'
  },
  benefitIcon:{},
  benefitText:{},
  benefitsContainer:{
    display: 'flex',
    gap: '20px',
    '& $benefitIconContainer':{
      width: '24px',
      height: '24px',
      '& $benefitIcon':{
        width: '24px',
        height: '24px',
      },
    },
    '& $benefitText':{
      display: 'flex',
      flexDirection: 'column',
      width: '100%'
    }
  },
  boardTooltip: {
    position: 'absolute',
    maxWidth: '580px',
    marginRight: '10px',
    display: 'table',
    backgroundColor: '#fff',
    font: "300 14px 'Roboto', sans-serif",
    padding: '28px',
    zIndex: '600',
    boxSizing: 'border-box',
    border: '1px solid #D8D8D8',
    '@media (min-width:801px)': {
      maxWidth: '750px',
      padding: '28px 24px',
      marginRight: 'unset'
    },
  },
  tooltipPointerStyle: {
    backgroundColor: '#fff',
    width: '30px',
    height: '30px',
    borderLeft: '1px solid #D8D8D8',
    borderBottom: '1px solid #D8D8D8',
  },
  tooltipBenefitText: {
    '& div': {
      display: 'flex',
      flexWrap: 'wrap',
      flexDirection: 'row',
      alignItems: 'flex-start',
      lineHeight: '24px',
      height: '100%',
      maxHeight: '200px',
      overflow: 'auto',
      '@media (min-width:801px)': {
        maxHeight: '420px',
      },
      '& p': {
        width: '44%',
        margin: '0 20px 0 0',
        '@media (min-width:801px)': {
          width: '50%',
        },
      },
    },
  },
  stModalTitle:{
    color: data => data.STgoldEurostars,
  },
  benefitIconContainer:{}
};
